export default "__VITE_ASSET__CUUDy8eG__"